import { useContext } from "react";
import { TranslationContext } from "../Pages/TranslationContext";
import { sendPostRequest } from "../Client/index.js";

export function useGetTranslation() {
  const translations = useContext(TranslationContext)?.data || {};

  const getTranslation = (code, fallback, placeholders) => {
    const translation = translations[code];

    if (translation) {
      return replace(translation, placeholders);
    } else {
      reportMissingTranslation(code, fallback);
      return replace(fallback, placeholders);
    }

  };

  const replace = (text, placeholders) => {
    if (placeholders) {
      Object.keys(placeholders).forEach((key) => {
        text = text.replace(`{${key}}`, placeholders[key]);
      });
    }
    return text;

  }

  const reportMissingTranslation = async (code, fallback) => {
    try {
      const res = await sendPostRequest(
        "api/v2-label-portal-translations-missing.php",
        {
          code,
          fallbackText: fallback,
        }
      );
    } catch (error) {}
  };

  return getTranslation;
}
